import React, { useEffect, useState } from "react";
import { useSelector, connect } from "react-redux";
import { useLocation } from "react-router-dom";
import FreeInvite from "../free/pages/invite/invite";
import StandardInvite from "../standard/pages/invite/invite";
import PremiumInvite from "../premium/pages/invite/invite";
import authHeader from "../services/auth/auth-header";
import { getApi } from "../services/helpers/apiCall";
import { toAbsoluteUrl } from "../services";
import { useNavigate } from "react-router-dom";
import ROUTES from "../free/constants/routes";

// get step data from redux main state
const authData = (state) => state.auth;

const MainInvite = (props) => {
  const [campaignType, setCampaignType] = useState("");
  const [currentType, setCurrentUserType] = useState("");
  const [loading, setLoading] = useState(false);
  const [templateData, setCampaignTemplateData] = useState(null);
  let navigate = useNavigate();

  let client = useSelector(authData);

  let getCampaignType = async (campaignId) => {
    setLoading(true);
    let { userType } = client?.client;

    const { data } = await getApi({
      url: `/auth/campaign/config/${campaignId}`,
      data: {},
      config: {
        headers: authHeader(),
      },
    });

    const allData = await getApi({
      url: `campaigns/${campaignId}`,
      data: {},
      config: {
        headers: authHeader(),
      },
    });
    const resp = data.components[0]?.saas;
    const emailTemp = allData.data;

    let { emailTemplate, emailSubject, campaignEmail } = emailTemp;
    let templateData = {
      emailSubject,
      emailTemplate,
      campaignEmail,
    };

    setCampaignTemplateData(templateData);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    setCampaignType(resp.type);
    setCurrentUserType(userType);
  };

  const updateGetTemplateData = async (campaignId) => {
    const allData = await getApi({
      url: `campaigns/${campaignId}`,
      data: {},
      config: {
        headers: authHeader(),
      },
    });
    const emailTemp = allData.data;
    let { emailTemplate, emailSubject, campaignEmail } = emailTemp;
    let templateData = {
      emailSubject,
      emailTemplate,
      campaignEmail,
    };
    setCampaignTemplateData(templateData);
  };

  const { state } = useLocation();

  useEffect(() => {
    if (!state || !state.campaignId) {
      navigate(`${ROUTES.HOME}`, { replace: true });
    } else {
      getCampaignType(state?.campaignId);
    }
  }, []);
  return (
    <div>
      {loading ? (
        <div className="flex mt-24 flex-col justify-center items-center">
          <img
            src={toAbsoluteUrl("/media/dashboard/logo.gif")}
            alt="TTG LOGO"
            style={{
              width: "100px",
              height: "90px",
            }}
          />
          <p className="font-semibold text-xl ">Please Wait...</p>
        </div>
      ) : (
        <>
          {campaignType === "free" ? (
            <FreeInvite
              updateGetTemplateData={updateGetTemplateData}
              templateData={templateData}
              currentType={currentType}
            />
          ) : campaignType === "standard" ? (
            <StandardInvite
              updateGetTemplateData={updateGetTemplateData}
              templateData={templateData}
              currentType={currentType}
            />
          ) : campaignType === "premium" ? (
            <PremiumInvite
              updateGetTemplateData={updateGetTemplateData}
              templateData={templateData}
              currentType={currentType}
            />
          ) : null}
        </>
      )}
    </div>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {})(MainInvite);
